import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const PaymentInstructions = () => {
  const { profile, getUserLevel } = useAuth();

  const getLevelInfo = () => {
    const levels = {
      grade7: { name: 'Grade 7', price: 'K500', number: '1' },
      form2: { name: 'Form 2', price: 'K1000', number: '2' },
      grade12: { name: 'Grade 12', price: 'K1500', number: '3' }
    };
    return levels[getUserLevel()] || { name: 'Unknown', price: 'K0', number: '0' };
  };

  const levelInfo = getLevelInfo();

  const paymentMethods = [
    {
      name: 'Airtel Money',
      number: '0972553255',
      instructions: [
        'Dial *115# or open Airtel Money app',
        'Select "Send Money"',
        'Enter our business number: 0972553255',
        'Enter amount: ' + levelInfo.price,
        'Enter your reference: ZS' + levelInfo.number + profile?.uid?.slice(-6),
        'Confirm and complete the transaction'
      ]
    }
  ];

  return (
    <div className="payment-instructions">
      <div className="container">
        <div className="page-header">
          <h1>Payment Instructions</h1>
          <p>Complete your subscription payment using mobile money</p>
        </div>

        <div className="payment-summary">
          <div className="summary-card">
            <h3>Subscription Details</h3>
            <div className="summary-item">
              <label>Education Level:</label>
              <span>{levelInfo.name}</span>
            </div>
            <div className="summary-item">
              <label>Subscription Fee:</label>
              <span className="price">{levelInfo.price}</span>
            </div>
            <div className="summary-item">
              <label>Duration:</label>
              <span>1 Year (until December 31st)</span>
            </div>
            <div className="summary-item">
              <label>Your Reference:</label>
              <span className="reference">ZS{levelInfo.number}{profile?.uid?.slice(-6)}</span>
            </div>
          </div>
        </div>

        <div className="payment-methods">
          <h2>Available Payment Methods</h2>
          <div className="methods-grid">
            {paymentMethods.map((method, index) => (
              <div key={index} className="method-card">
                <div className="method-header">
                  <h3>{method.name}</h3>
                  <div className="method-number">{method.number}</div>
                </div>
                
                <div className="method-instructions">
                  <h4>How to Pay:</h4>
                  <ol>
                    {method.instructions.map((instruction, idx) => (
                      <li key={idx}>{instruction}</li>
                    ))}
                  </ol>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="important-notes">
          <h2>Important Notes</h2>
          <div className="notes-grid">
            <div className="note-card">
              <div className="note-icon">⚠️</div>
              <h4>Use Correct Reference</h4>
              <p>Always use your unique reference number: <strong>ZS{levelInfo.number}{profile?.uid?.slice(-6)}</strong></p>
            </div>
            
            <div className="note-card">
              <div className="note-icon">📸</div>
              <h4>Keep Receipt</h4>
              <p>Save your transaction confirmation message. You'll need it to submit your payment proof.</p>
            </div>
            
            <div className="note-card">
              <div className="note-icon">⏰</div>
              <h4>Processing Time</h4>
              <p>Payments are typically reviewed within 1 hour during business days.</p>
            </div>
            
            <div className="note-card">
              <div className="note-icon">✅</div>
              <h4>Activation</h4>
              <p>Your subscription will be activated immediately after payment approval.</p>
            </div>
          </div>
        </div>

        <div className="next-steps">
          <h2>After Payment</h2>
          <div className="steps-flow">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h4>Make Payment</h4>
                <p>Complete the payment using any of the methods above</p>
              </div>
            </div>
            
            <div className="step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h4>Submit Proof</h4>
                <p>Fill out the payment submission form with your transaction details</p>
              </div>
            </div>
            
            <div className="step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h4>Wait for Approval</h4>
                <p>Our team will review and approve your payment</p>
              </div>
            </div>
            
            <div className="step">
              <div className="step-number">4</div>
              <div className="step-content">
                <h4>Start Learning</h4>
                <p>Access all study materials once your subscription is activated</p>
              </div>
            </div>
          </div>
          
          <div className="action-buttons">
            <Link to="/payment/submit" className="btn btn-primary btn-large">
              Submit Payment Proof
            </Link>
            <Link to="/dashboard" className="btn btn-secondary btn-large">
              Back to Dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentInstructions;
